const idCardTypePH = {
  taxpayerIdentificationNumber: 'Taxpayer Identification Number (TIN)',
  socialSecuritySystem: 'Social Security System (SSS)',
  governmentServiceInsuranceSystem: 'Government Service Insurance System (GSIS)'
};

export default idCardTypePH;
